/** Clé session : une seule tentative de rechargement automatique par incident (évite boucles). */
export const CHUNK_LOAD_RELOAD_SESSION_KEY = 'lyrra:chunk-load-reload-once';

export function isChunkLoadFailure(reason: unknown): boolean {
  if (!reason) return false;
  const message =
    typeof reason === 'string'
      ? reason
      : reason instanceof Error
        ? reason.message
        : typeof reason === 'object' && reason !== null && 'message' in reason
          ? String((reason as { message?: unknown }).message ?? '')
          : '';

  if (!message) return false;
  const lower = message.toLowerCase();
  return (
    lower.includes('failed to fetch dynamically imported module') ||
    lower.includes('error loading dynamically imported module') ||
    lower.includes('importing a module script failed') ||
    lower.includes('loading chunk') ||
    lower.includes('chunkloaderror') ||
    lower.includes('unable to preload css') ||
    /loading css chunk \d+ failed/i.test(message)
  );
}
